export const glCodeAliasesEn = {
  SAVE_GL_CODE_ALIAS: 'Save',
  GL_CODE_ALIASES: 'Classic GL Code Aliases',
  GL_CODE_ALIASES_INFO:
    'Alias how a classic GL code purpose reads on your ledgers and exports — its code and/or its label. This retroactively updates every ledger already posted with this purpose, not just new ones.',
  GL_CODE_TYPE: 'Purpose',
  CLASSIC_GL_CODE: 'Default Code',
  GL_CODE_ALIAS_CODE: 'Code',
  CURRENT_GL_CODE: 'Current Code',
  DEFAULT_GL_CODE_TOOLTIP: "FactorCloud's default code for this purpose.",
  CURRENT_GL_CODE_TOOLTIP: "The currently set code — this is what you'll see across every screen in the application.",
  DEFAULT_DESCRIPTION: 'Default Description',
  CURRENT_DESCRIPTION: 'Current Description',
  USING_DEFAULT: 'Using default',
  CUSTOMIZED: 'Customized',
  GL_CODE_ALIAS_STATUS: 'Status',
  EDIT_GL_CODE_ALIAS: 'Edit GL Code Alias',
  REVERT_TO_DEFAULT: 'Revert to default',
  REVERT_TO_DEFAULT_CONFIRMATION: 'Are you sure you want to revert this code/description back to the classic default? This updates every ledger already posted with this purpose — it may take a few minutes to fully reflect.',
  SAVE_GL_CODE_ALIAS_CONFIRMATION: 'Are you sure you want to save this alias? This updates every ledger already posted with this purpose — it may take a few minutes to fully reflect.',
  GL_CODE_ALIAS_SAVED: 'GL code alias updated. Already-posted ledgers may take a few minutes to fully reflect the change.',
  GL_CODE_ALIAS_REVERTED: 'GL code alias reverted to the classic default. Already-posted ledgers may take a few minutes to fully reflect the change.',
  GL_CODE_ALIAS_REQUIRED: 'At least a code or a description is required.',
  ERROR_LOADING_GL_CODE_ALIASES: 'Error loading GL code aliases. Please try again.',
}

export const glCodeAliasesEs: typeof glCodeAliasesEn = {
  SAVE_GL_CODE_ALIAS: 'Guardar',
  GL_CODE_ALIASES: 'Alias de Códigos GL Clásicos',
  GL_CODE_ALIASES_INFO:
    'Definí un alias para cómo se muestra un propósito de código GL clásico en tus libros y exportaciones — su código y/o su etiqueta. Esto actualiza retroactivamente todos los libros ya registrados con este propósito, no solo los nuevos.',
  GL_CODE_TYPE: 'Propósito',
  CLASSIC_GL_CODE: 'Código por Defecto',
  GL_CODE_ALIAS_CODE: 'Código',
  CURRENT_GL_CODE: 'Código Actual',
  DEFAULT_GL_CODE_TOOLTIP: 'El código por defecto de FactorCloud para este propósito.',
  CURRENT_GL_CODE_TOOLTIP: 'El código actualmente seteado — es el que vas a ver en todas las pantallas de la aplicación.',
  DEFAULT_DESCRIPTION: 'Descripción por Defecto',
  CURRENT_DESCRIPTION: 'Descripción Actual',
  USING_DEFAULT: 'Usando valor por defecto',
  CUSTOMIZED: 'Personalizado',
  GL_CODE_ALIAS_STATUS: 'Estado',
  EDIT_GL_CODE_ALIAS: 'Editar Alias de Código GL',
  REVERT_TO_DEFAULT: 'Volver al valor por defecto',
  REVERT_TO_DEFAULT_CONFIRMATION: '¿Estás seguro de que querés volver este código/descripción al valor clásico por defecto? Esto actualiza todos los libros ya registrados con este propósito — puede demorar unos minutos en reflejarse por completo.',
  SAVE_GL_CODE_ALIAS_CONFIRMATION: '¿Estás seguro de que querés guardar este alias? Esto actualiza todos los libros ya registrados con este propósito — puede demorar unos minutos en reflejarse por completo.',
  GL_CODE_ALIAS_SAVED: 'Alias de código GL actualizado. Los libros ya registrados pueden demorar unos minutos en reflejar el cambio por completo.',
  GL_CODE_ALIAS_REVERTED: 'Alias de código GL vuelto al valor por defecto. Los libros ya registrados pueden demorar unos minutos en reflejar el cambio por completo.',
  GL_CODE_ALIAS_REQUIRED: 'Se requiere al menos un código o una descripción.',
  ERROR_LOADING_GL_CODE_ALIASES: 'Error al cargar los alias de códigos GL. Por favor, intentá de nuevo.',
}
